import { useState } from 'react';
import { AdminInvitesTab } from '../components/admin/AdminInvitesTab';
import { AdminDatacentersTab } from '../components/admin/AdminDatacentersTab';
import { AiConfigForm } from '../components/admin/AiConfigForm';

type Tab = 'invites' | 'datacenters' | 'ai';

export default function AdminPage() {
  const [tab, setTab] = useState<Tab>('invites');

  return (
    <div style={{
      padding: '24px 28px',
      maxWidth: 1100,
      margin: '0 auto',
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#f3f4f6', margin: 0 }}>
          Администрирование
        </h1>
        <p style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
          Управление доступом и конфигурацией ЦОДов
        </p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid #1f2937', paddingBottom: 0 }}>
        {([['invites', 'Инвайт-коды'], ['datacenters', 'Дата-центры'], ['ai', 'AI / LLM']] as [Tab, string][]).map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)}
            style={{
              padding: '7px 16px', fontSize: 13, fontWeight: 500,
              background: 'none', border: 'none', cursor: 'pointer',
              color: tab === key ? '#60a5fa' : '#6b7280',
              borderBottom: tab === key ? '2px solid #3b82f6' : '2px solid transparent',
              marginBottom: -1, transition: 'all 0.15s',
            }}>
            {label}
          </button>
        ))}
      </div>

      {/* Content */}
      {tab === 'invites' && <AdminInvitesTab />}
      {tab === 'datacenters' && <AdminDatacentersTab />}
      {tab === 'ai' && <AiConfigForm />}
    </div>
  );
}
